import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { FC, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { notesApi } from 'src/api/notesApi';
import toast from 'react-hot-toast';
import {
  ClassicEditor,
  AutoImage,
  BlockQuote,
  Bold,
  Essentials,
  Heading,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  ListProperties,
  Paragraph,
  SimpleUploadAdapter,
  TextTransformation,
  Table,
  TableToolbar,
  MediaEmbed,
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import { userApi } from 'src/api/userApi';

const NoteCard: FC<any> = ({ notesData, setIsUpdate, isUpdate }: any) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [noteTitle, setNoteTitle] = useState(notesData.title);
  const [description, setDescription] = useState(notesData.text);
  const [expanded, setExpanded] = useState(false);

  function uploadAdapter(loader) {
    return {
      upload: () =>
        new Promise((resolve) => {
          loader.file.then(async (file) => {
            const formData = new FormData();
            formData.append('file', file);
            const image = await userApi.uploadAttachments(formData);
            resolve({
              default: `${image?.data?.blob_url}`,
            });
          });
        }),
    };
  }
  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
      uploadAdapter(loader);
  }

  const editorConfig = {
    toolbar: {
      items: [
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        '|',
        'link',
        'blockQuote',
        'insertImage',
        'undo',
        'redo',
        '|',
        'bulletedList',
        'numberedList',
        'outdent',
        'indent',
        'insertTable',
        'mediaEmbed',
      ],
      shouldNotGroupWhenFull: false,
    },
    plugins: [
      AutoImage,
      BlockQuote,
      Bold,
      Essentials,
      Heading,
      ImageBlock,
      ImageCaption,
      ImageInline,
      ImageResize,
      ImageStyle,
      ImageTextAlternative,
      ImageToolbar,
      ImageUpload,
      Indent,
      IndentBlock,
      Italic,
      Link,
      List,
      ListProperties,
      Paragraph,
      SimpleUploadAdapter,
      TextTransformation,
      Table,
      TableToolbar,
      MediaEmbed,
    ],
    blockToolbar: [
      'bold',
      'italic',
      '|',
      'link',
      '|',
      'bulletedList',
      'numberedList',
      'outdent',
      'indent',
    ],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph',
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Heading 1',
          class: 'ck-heading_heading1',
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2',
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Heading 3',
          class: 'ck-heading_heading3',
        },
      ],
    },
    image: {
      toolbar: [
        'toggleImageCaption',
        'imageTextAlternative',
        '|',
        'imageStyle:inline',
        'imageStyle:wrapText',
        'imageStyle:breakText',
        '|',
        'resizeImage',
      ],
    },
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
    },
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file',
          },
        },
      },
    },
    list: {
      properties: {
        styles: true,
        startIndex: true,
        reversed: true,
      },
    },

    extraPlugins: [uploadPlugin],
    placeholder: 'Enter your description here',
  };

  const handleDelete = async (e) => {
    if (e.target.value === 'Delete') {
      try {
        const response = await notesApi.deleteNote(notesData.id);
        if (response?.status === 200) {
          toast.success('Note Deleted');
          setIsUpdate(!isUpdate);
        }
      } catch (error) {
        if (error?.response?.status === 409) {
          toast.error(`${error?.response?.data?.message}`);
        } else {
          toast.error('Internal Server Error');
        }
      }
    }
  };

  const handleUpdate = async () => {
    const payload = {
      title: noteTitle,
      text: description,
    };
    setIsSubmitting(true);
    try {
      const response = await notesApi.updateNote(notesData.id, payload);
      if (response?.status === 200) {
        setIsSubmitting(false);
        setIsUpdate(!isUpdate);
        setExpanded(false);
        toast.success('Note Updated');
      }
    } catch (error) {
      toast.success(`${error?.message}`);
    }
  };
  return (
    <Accordion className="addMeetingCard" expanded={expanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className="accordionSummary"
        aria-controls="panel1a-content"
        id="panel1a-header"
        onClick={() => setExpanded(!expanded)}>
        <div className="meetingCardTitle&Desc">
          <Typography sx={{ fontWeight: 'bold' }}>
            {notesData?.title}
          </Typography>
          {/* eslint-disable-next-line react/no-danger */}
          <Typography dangerouslySetInnerHTML={{ __html: notesData?.text }} />
        </div>
        <div className="noteCardActions">
          <Select
            labelId="outcomeLabel"
            id="select"
            value=" "
            variant="standard"
            disableUnderline
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => handleDelete(e)}>
            <MenuItem value=" ">Actions</MenuItem>
            <MenuItem value="Delete">Delete</MenuItem>
          </Select>
          <Typography className="meetingCardDate">
            {` ${new Date(notesData?.createdAt).toLocaleString()} `}
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={4}>
          <Grid item md={12}>
            <Typography>Title</Typography>
            <TextField
              placeholder="Enter Title"
              fullWidth
              inputProps={{ maxLength: 225 }}
              value={noteTitle}
              onChange={(e) => setNoteTitle(e.target.value)}
            />
          </Grid>
          <Grid item md={12}>
            <div className="ckEditor">
              <Typography>Description</Typography>
              <CKEditor
                editor={ClassicEditor}
                data={description}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setDescription(data);
                }}
                config={editorConfig as any}
              />
            </div>
          </Grid>
        </Grid>

        {isSubmitting ? (
          <div className="loadingCircle">
            <CircularProgress />
          </div>
        ) : (
          <Button
            className="createButton"
            variant="contained"
            color="secondary"
            onClick={handleUpdate}>
            Update
          </Button>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default NoteCard;
